<script>
	import {onMount} from 'svelte'
	import {API,http_headers} from '../global.js'
	export let close = ()=>alert("Funcion no implementada")
	export let periodo = {}


	let data = []
	let monedas = ['--','$','U$s']
	let complejos = [' ','RDA','RDE']
	let agrup = { ejecutivo : true, pagotipo: false}

	let select = ''
	let group_by = ''
	let order_by = ''
	let where = ''
	let update = false
	let f1 = ''
	let f2 = ''
	let _finicio = f1 = periodo.finicio.substring(0,10)
	let _ffin = f2 = periodo.ffin.substring(0,10)


	$: make_data = () => {

		where = `lastupdate >='${_finicio}' and lastupdate<'${_ffin}'`
		group_by = ' group by t.complejo,t.moneda'
		order_by = ' order by t.complejo,t.moneda'
		select = ''

		if(agrup.ejecutivo){
			select = ',t.ejecutivo'
			group_by += ',t.ejecutivo'
			order_by += ',t.ejecutivo'
		}

		if(agrup.pagotipo){
			select += ',t.pagotipo'
			group_by += ',t.pagotipo'
			order_by += ',t.pagotipo'
		}

		
		
		return fetchData()
	}

	const refrescar = () => {
		_finicio = f1
		_ffin = f2
	}

	const money = (val) => {
		let numero = parseFloat(val)
		if(isNaN(numero)) return '0.00'
		numero = Math.round(numero*100)
		let numeroString = numero.toString()

		let largo = numeroString.length

		if(largo==1) {
			numeroString = '0.0'+numeroString
			return numeroString
		}
		if(largo==2) {
			numeroString = '0.'+numeroString
			return numeroString
		}
		

		numeroString = (numeroString.split('')) //.splice(largo-2,0,'.')
		numeroString.splice(largo-2,0,',')
		numeroString = numeroString.reverse()
		let control = 6
		while (control < numeroString.length){
			numeroString.splice(control,0,'.')
			control +=4
		}
		numeroString.reverse()
		return numeroString.join('')
	}

	const fetchData = async () => {
		let query = `select t.complejo,t.moneda ${select} ,sum(importe) importe,count(*) cantidad from (
					  select w.*, substring(w.concepto,1,3) pagotipo
					   ,(select u.usuario  from clientes c
					          left join usuarios u on u.idusuario=c.idejecutivo
					          where c.idcliente=w.idcliente) ejecutivo
					   from w_payrequests w
					        left join cierres_periodos cp on cp.periodo='${periodo.periodo}'
					  where w.tipo='CAM' and w.estado='OK'
					  and ${where} 
					  ) t ${group_by} ${order_by}`

					  /*
					  lastupdate >='${_finicio}' and lastupdate<'${_ffin}'
					  group by t.ejecutivo,t.moneda,t.complejo,t.pagotipo
					order by t.complejo,t.moneda,t.ejecutivo,t.pagotipo
					*/
		let rs = await fetch(`${API}/exec-query?u=false`,
			{
				method:'POST',
				headers: http_headers,
				body:JSON.stringify({query})	
			})
		let ds = await rs.json()
		if(ds.success) {
			return ds.data
		} else {
			return []
		}

	}


</script>

<div class="modal fade show " style="display: block;background-color: rgba(50, 50, 50, .3);"  aria-modal="true" 
	id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-scrollable"  style="max-width:800px;">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Estadisticas</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" on:click={close}></button>
      </div>
      <div class="modal-body">

      	<p>
      		Desde: <input tabindex="-1" type="text" bind:value="{f1}">
      		Hasta: <input tabindex="-1" type="text" bind:value="{f2}">
      		<button on:click={()=>refrescar()}>&circlearrowright;</button>
      	</p>

		<div class="form-check form-check-inline">
		  <input class="form-check-input" type="checkbox" id="inlineCheckbox2" bind:checked="{agrup.ejecutivo}">
		  <label class="form-check-label" for="inlineCheckbox2">Ejecutivo</label>
		</div>
		<div class="form-check form-check-inline">
		  <input class="form-check-input" type="checkbox" id="inlineCheckbox3" bind:checked="{agrup.pagotipo}">
		  <label class="form-check-label" for="inlineCheckbox3">Tipo Pago</label>
		</div>


        <table class="table table-sm">
        	<thead>
        		<tr>
        			<td>Ejecutivo</td>
        			<td>Complejo</td>
        			<td>Tipo Pago</td>
        			<td>Moneda</td>
        			<td>Importe</td>
				<td>Cantidad</td>
        		</tr>
        	</thead>
        	<tbody>
        		{#await make_data()}
        			<i class="spinner"></i>
        		{:then ds}
	        		{#each ds as reg}
	      				<tr>
	      					<td>{reg.ejecutivo||''}</td>
	      					<td>{complejos[reg.complejo]}</td>
	      					<td>{reg.pagotipo||''}</td>
	      					<td class="text-center">{monedas[reg.moneda]}</td>
	      					<!-- <td class="text-end">{reg.importe.toFixed(2)}</td> -->
	      					<td class="text-end">{money(reg.importe)}</td>
						<td>{reg.cantidad||0}</td>
	      				</tr>
	        		{/each}
	        	{:catch err}
					  	<p>No hay datos {err}</p>
				{/await}
        	</tbody>
        </table>
      	
      	

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" on:click={close}>Salir</button>
        <!-- <button type="button" class="btn btn-primary">Save changes</button> -->
      </div>
    </div>
  </div>
</div>

